






import Vue from "vue";

import { UpdatePackageAssociationEnum } from "@/model/data/updates/UpdatePackageAssociationEnum";

export default Vue.extend({
    data() {
        return {
            internalCheck: false,
            internalIndeterminate: false,
        };
    },
    props: {
        value: {
            type: Number,
            required: true,
        },
    },
    watch: {
        internalCheck() {
            this.internalIndeterminate = false;
            this.emitEvent();
        },
    },
    methods: {
        emitEvent() {
            if (this.internalCheck == true) this.$emit("input", UpdatePackageAssociationEnum.all);
            else this.$emit("input", UpdatePackageAssociationEnum.none);

            // non andrò mai ad scatenare l'evento di questo tipo
            /* if (this.internalIndeterminate == true) this.$emit('input', UpdatePackageAssociationEnum.partial); */
        },
    },
    mounted() {
        if ((this.value as UpdatePackageAssociationEnum) == UpdatePackageAssociationEnum.all) {
            this.internalCheck = true;
            this.internalIndeterminate = false;
        } else if ((this.value as UpdatePackageAssociationEnum) == UpdatePackageAssociationEnum.partial) {
            this.internalCheck = false;
            this.internalIndeterminate = true;
        } else if ((this.value as UpdatePackageAssociationEnum) == UpdatePackageAssociationEnum.none) {
            this.internalCheck = false;
            this.internalIndeterminate = false;
        }
    },
});
